/** The sentence to show for a failed result. The client's error classes already write `message` as one. */
export function errorText(errors: readonly Error[]): string {
  return errors[0]?.message ?? "Something went wrong.";
}

/** The sentence for a thrown value, where a transport failure surfaces as an exception. */
export function thrownText(error: unknown, fallback = "Something went wrong."): string {
  return error instanceof Error ? error.message || fallback : fallback;
}
